<template>
  <div class="chat">
    <div class="search">
      <v-text-field
        v-model="keyword"
        class="keyword"
        label="搜尋聊天紀錄"
        prepend-inner-icon="fa-search"
        solo
        rounded
        dense
        hide-details
        @keydown.enter=""
      >
      </v-text-field>
      <v-menu bottom>
        <template v-slot:activator="{ on, attrs }">
          <div class="px-4 pointe text-no-wrap" v-bind="attrs" v-on="on">
            {{ filterTypes[filter].text }}
            <v-icon x-small class="ml-1">fa-chevron-down</v-icon>
          </div>
        </template>
        <v-list>
          <v-list-item-group v-model="filter" color="pink" mandatory>
            <v-list-item v-for="type in filterTypes" :key="type.text">
              <v-list-item-title>{{ type.text }}</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>
    </div>
    <div class="chat-list" v-infinite-scroll="getChatrooms" infinite-scroll-disabled="busy" infinite-scroll-distance="150">
      <v-list-item 
        v-for="room in chatrooms" 
        :key="room.id"
        class="py-1" 
        @click="$router.push({name: 'Portal_Chatroom', params: {room: room, room_id: room.id}})"
      >
        <v-list-item-avatar size="45">
          <v-img :src="$HOST_URL + room.member.usericon"/>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title v-text="room.member.nickname"></v-list-item-title>
          <v-list-item-subtitle v-if="room.latest_message.type == 'text'" v-text="room.latest_message.text"></v-list-item-subtitle>
          <v-list-item-subtitle v-if="room.latest_message.type == 'image'">[圖片]</v-list-item-subtitle>
          <v-list-item-subtitle v-if="room.latest_message.type == 'video'">[影片]</v-list-item-subtitle>
          <v-list-item-subtitle v-if="room.latest_message.type == 'audio'">[語亯]</v-list-item-subtitle>
          <v-list-item-subtitle v-if="room.latest_message.type == 'gift'">[禮物]</v-list-item-subtitle>
          <v-list-item-subtitle v-if="room.latest_message.type == 'product'">[解鎖商品]</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-avatar size="22" class="pink white--text font-weight-bold" v-if="room.seller_unreaded > 0">{{ room.seller_unreaded }}</v-avatar>
          <v-avatar size="22" v-else></v-avatar>
          <span v-if="$func.dayDiff(room.latest_message.created_at) === 0">
            {{ room.latest_message.created_at | time }}
          </span>
          <span v-else-if="$func.dayDiff(room.latest_message.created_at) === 1">
            昨天 {{ room.latest_message.created_at | time }}
          </span>
          <span v-else-if="$func.isThisYear(room.latest_message.created_at)">
            {{ room.latest_message.created_at | dateWithoutYear }}
          </span>
          <span v-else>{{ room.latest_message.created_at | dateWithYear }}</span>
        </v-list-item-action>
      </v-list-item>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  data() {
    return {
      filterTypes: [
        { text: '全部', value: ''},
        { text: '未讀', value: 0}
      ],
      busy: false,
      page: 1,
      keyword: '',
      filter: 0,
      chatrooms: []
    }
  },
  channel() {
    return `private:seller.${ this.seller.id }`
  },
  echo: {
    SendToChat(response) {
      let current_room = this.chatrooms.find(room => room.member.id == response.sender.id)
      if(current_room) {
        this.chatrooms.splice(current_room, 1)
      }
      let room = {
        id: response.message.chat_id,
        member: response.sender,
        latest_message: response.message,
        seller_unreaded: current_room.seller_unreaded + 1
      }
      this.chatrooms.unshift(room)
    }
  },
  mounted() {
    
  },
  computed: {
    ...mapState('seller', ['seller']),
    read() {
      return this.filterTypes[this.filter].value
    },
  },
  methods: {
    getChatrooms() {
      this.busy = true
      this.axios(`/portal/chat?page=${this.page}&size=20`).then(response => {
        this.chatrooms = this.chatrooms.concat(response.data.data)
        if(this.page != response.data.last_page) {
          this.page += 1
          this.busy = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.chat {
  .search {
    display: flex;
    align-items: center;
    padding: 24px;
    @include mobile {
      padding: 24px 12px;
    }
    .keyword {
      .v-icon {
        font-size: 16px;
        margin-right: 12px;
      }
    }
  }
  .chat-list {
    overflow: auto;
    max-height: calc(100vh - 201px);
    padding-bottom: 24px;
    .v-list-item {
      position: relative;
      &:hover {
        cursor: pointer;
        background-color: lightgrey;
      }
      .v-list-item__title {
        color: $grey-4;
        font-weight: 500;
      }
      .v-list-item__subtitle {
        line-height: 1.5;
        color: #888 !important;
      }
      .v-list-item__content {
        padding: 8px 0;
      }
      .v-list-item__action {
        color: #888 !important;
        font-size: 12px;
        margin: 8px 0;
      }
    }
  }
}
</style>